import { Avatar, IconButton } from '@mui/material';
import axios from 'axios';
import ls from 'local-storage';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

import Icon from '@/components/icon';
import firebaseApp from '@/config/firebase.config';
import Placeholder from '@/config/placeholder.config';
import PlaceholderDark from '@/config/placeholder-dark.config';
import { Constants } from '@/constants';
import { UserStore } from '@/stores';

const UserMenu: React.FC = () => {
  const currentUser = UserStore.useState((s) => s.firebaseUser);
  const darkMode = true; // TODO Pull from state - for now, no dark mode except in toolbar
  // Manage the open state for the Dropdown
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const [userImage, setUserImage] = useState<string>(
    currentUser?.photoURL ||
      (darkMode ? PlaceholderDark.avatar : Placeholder.avatar)
  );

  useEffect(() => {
    if (currentUser?.email) {
      axios
        .get(`${Constants.apiPath}/users`, {
          params: {
            q: currentUser?.email,
          },
        })
        .then((res) => {
          if (res.data.length > 0) {
            const user = res.data[0];
            setUserImage(
              user.image_url ||
                (darkMode ? PlaceholderDark.avatar : Placeholder.avatar)
            );
          }
        })
        .catch((e) => {});
    }
  }, [currentUser]);

  const logOut = (e: React.MouseEvent) => {
    e.preventDefault();
    firebaseApp
      .auth()
      .signOut()
      .then(() => {
        UserStore.update((s) => {
          s.firebaseUser = null;
          s.user = null;
          s.authenticated = false;
          ls('boxpressd_admin_token_id', 0);
        });
      })
      .catch((error) => {
        UserStore.update((s) => {
          s.firebaseUser = null;
          s.user = null;
          s.authenticated = false;
          ls('boxpressd_admin_token_id', 0);
        });
      });
  };

  const renderMenuItems = () => (
    <>
      <li>
        <a
          href="https://help.boxpressd.com/support/solutions/150000047760"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link"
        >
          <Icon name="help-circle" />
          <span>Help & Support</span>
          <span className="rui-nav-circle" />
        </a>
      </li>
      <hr />
      <li>
        <a
          id="toggle-feedback"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            if (window.fcWidget) {
              const fcFrame = document.getElementById('fc_frame');
              if (fcFrame) {
                fcFrame.style.display = 'block';
                window.fcWidget.open({ name: 'Feedback' });
              }
            }
          }}
          className="nav-link"
        >
          <Icon name="edit" />
          <span style={{ maxHeight: 25 }}>
            {'Leave Feedback'}
            <br />
            <p style={{ fontSize: 10 }}>
              Help us improve your experience with Boxpressd
            </p>
          </span>
          <span className="rui-nav-circle" />
        </a>
      </li>
      <hr />
      {/* <li className="dropdown-menu-label" style={{ opacity: 0.5 }}> */}
      {/*  Display Options */}
      {/* </li> */}
      <li>
        <Link
          to="/settings"
          className="nav-link"
          onClick={() => setDropdownOpen(false)}
        >
          <Icon name="settings" />
          <span>Settings</span>
        </Link>
      </li>
      <hr />
      <li>
        <Link to="#" className="nav-link" onClick={logOut}>
          <Icon name="log-out" />
          <span>Log Out</span>
          <span className="rui-nav-circle" />
        </Link>
      </li>
    </>
  );

  return (
    <Dropdown direction="down" isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        tag="a"
        href="#"
        className="dropdown-item rui-navbar-avatar mnr-6"
      >
        <IconButton onClick={() => {}} sx={{ p: 0 }}>
          <Avatar
            alt={currentUser ? currentUser.full_name : ''}
            src={userImage}
          >
            <img
              alt={currentUser ? currentUser.full_name : ''}
              src={darkMode ? PlaceholderDark.avatar : Placeholder.avatar}
              style={{ height: 40, width: 40 }}
            />
          </Avatar>
        </IconButton>
      </DropdownToggle>
      <DropdownMenu
        className="nav dropdown-menu"
        style={{ width: 350, padding: 12 }}
      >
        {renderMenuItems()}
        <li>
          <div
            style={{
              textAlign: 'center',
              borderTop: '1px solid rgba(0, 0, 0, 0.1)',
              marginTop: 14,
              paddingTop: 14,
            }}
          >
            <div className="bottom-links" style={{ fontSize: 13 }}>
              <a href="https://boxpressd.com/legal/privacy">Privacy Policy</a>
              {' · '}
              <a href="https://boxpressd.com/legal/terms">Terms of Service</a>
              {' · '}
              <a href="https://boxpressd.com/ads">Advertising</a>
            </div>
            <span className="copyright" style={{ fontSize: 13 }}>
              Boxpressd &copy; {new Date().getFullYear()}
            </span>
          </div>
        </li>
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserMenu;
